import { render, staticRenderFns } from "./veStuReservationShen.vue?vue&type=template&id=96813218&scoped=true"
import script from "./veStuReservationShen.vue?vue&type=script&lang=js"
export * from "./veStuReservationShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96813218",
  null
  
)

export default component.exports